{
  "shcPP": {
    "addToCart": "Add to cart",
    "sku": "sku",
    "theProductDoesNotExist": "The product does not exist"
  }
}
